import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/Toaster';
import { useAuthStore } from './state/authStore';
import IntroPage from './pages/IntroPage';
import PrivacyPage from './pages/PrivacyPage';
import ProjectsPage from './pages/ProjectsPage';
import AccountPage from './pages/AccountPage';
import NotFoundPage from './pages/NotFoundPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import NewProjectWizardPage from './pages/wizard/NewProjectWizardPage';
import EditorPage from './pages/editor/EditorPage';
import PreviewPage from './pages/preview/PreviewPage';
import ExportPage from './pages/export/ExportPage';

export default function App() {
  const checkSession = useAuthStore((s) => s.checkSession);

  useEffect(() => {
    void checkSession();
  }, [checkSession]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<IntroPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/registreren" element={<RegisterPage />} />
        <Route path="/wachtwoord-vergeten" element={<ForgotPasswordPage />} />
        <Route path="/wachtwoord-herstellen" element={<ResetPasswordPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/projecten" element={<ProjectsPage />} />
        <Route path="/nieuw" element={<NewProjectWizardPage />} />
        <Route path="/editor/:projectId" element={<EditorPage />} />
        <Route path="/preview/:projectId" element={<PreviewPage />} />
        <Route path="/export/:projectId" element={<ExportPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}
